// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".two-columns-list__body{width:100%}.two-columns-list__body-inner{width:100%;display:grid;column-gap:32px;row-gap:32px;grid-template-columns:1fr 1fr;margin-top:32px}@media(max-width: 1024px){.two-columns-list__body-inner{margin-top:24px}}@media(max-width: 768px){.two-columns-list__body-inner{display:block}.two-columns-list__body-inner .phased-tournament-card{margin-bottom:16px}}.two-columns-list.--list .two-columns-list__body-inner{display:block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
